






import { Vue, Component, Prop } from "vue-property-decorator";

@Component({

})
export default class AttendButton extends Vue {

    @Prop() sessionId: string;
    @Prop() isPastSession: boolean;

}
